
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

// Preload the logo image
const logoUrl = "/lovable-uploads/d62a4e07-f701-4335-84a0-c9be341a0477.png";
const preloadImage = new Image();
preloadImage.src = logoUrl;

export const Hero = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div className="bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <img 
            src={logoUrl}
            alt="Bright Stages" 
            className="h-24 md:h-32 mx-auto mb-8 animate-float"
            loading="eager"
            fetchPriority="high"
            decoding="async"
            style={{ contentVisibility: "auto" }}
          />
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 font-heading">
            Track Your Child's Developmental Journey
          </h1>
          
          <p className="text-xl text-gray-600 md:text-2xl font-body">
            Monitor progress, celebrate achievements, and support growth with our research-backed developmental tracking platform.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <Button
              onClick={() => navigate("/login")}
              variant="default"
              className="text-lg px-8 py-6"
            >
              Sign In
            </Button>
            <Button
              onClick={() => navigate("/signup")}
              variant="outline"
              className="text-lg px-8 py-6 border-2 hover:bg-gray-50"
            >
              Create Account
            </Button>
          </div>
        </div>
      </div>
      
      {/* New Video Section with matching background */}
      <div className="bg-white py-8 md:py-16">
        <div className="container mx-auto">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-4 md:mb-10 font-heading">
              Preview Our Unique Platform
            </h2>
            <div className="mx-auto relative rounded-2xl overflow-hidden flex justify-center" 
                 style={{ maxWidth: "400px", height: isMobile ? "600px" : "700px" }}>
              <video 
                className="absolute h-full w-auto object-contain object-center"
                autoPlay
                muted
                loop
                playsInline
                poster="/placeholder.svg"
                style={{ objectPosition: "center center" }}
              >
                <source src="http://kidshonorroll.com//wp-content/uploads/2025/02/BrightStagesSample.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
